<!------------ START TEMPLATE ------------>
<template>
  <span class="text-center">
    <vs-button
      :color="variant"
      class="mb-2"
      @click="submit"
      v-if="aguarde == false"
      :disabled="disabled"
    >
      <span v-if="text != '' && text != null && text != undefined">{{
        text
      }}</span>
      <span v-else-if="edit != true">Cadastrar</span>
      <span v-else>Salvar Alterações</span>
    </vs-button>

    <vs-button :color="variant" type="gradient" class="mb-2" v-else>
      <vs-icon icon-pack="feather" icon="icon-loader"></vs-icon>
    </vs-button>
  </span>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
export default {
  props: ['variant', 'edit', 'aguarde', 'text', 'disabled'],
  data() {
    return {};
  },
  methods: {
    submit() {
      this.$emit('submit');
    },
  },
};
</script>
<!------------ END SCRIPT ------------>
